import React from 'react'
import Link from 'gatsby-link'
import styled from 'react-emotion'
import tinycolor from 'tinycolor2'

import Menu from '../Menu'
import logo from '../../../assets/images/HTSLogo2.svg'
import footerBg from '../../../assets/images/footer.jpg'

const FooterContainer = styled.footer`
  padding: 50px 20px;
  background-color: ${props => props.theme.white};
  background-image: url(${footerBg});
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  @media (min-width: 768px) {
    padding: 50px 75px;
  }

  a {
    text-decoration: none;

    &:hover {
      color: ${props => props.theme.primaryHighlight};
    }
  }
`

const Bar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  width: 100%;
  max-width: 1250px;
  flex-shrink: 0;
  margin: 0 auto;
  flex-direction: column;
  align-items: center;

  @media (min-width: 768px) {
    flex-direction: row;
  }

  hr {
    width: 100%;
  }

  span {
    font-size: 14px;
    color: ${props => props.theme.textColorLight};
  }

  ul {
    flex-direction: column;
    align-items: center;

    @media (min-width: 768px) {
      flex-direction: row;
    }

    @media (max-width: 768px) {
      li {
        margin-right: 0;
        margin-bottom: 1rem;
      }
    }
  }
`

const Logo = styled.img`
  height: 75px;
`

const Footer = () => (
  <FooterContainer>
    <Bar>
      <Link
        to="/"
        css={{
          textDecoration: 'none',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Logo src={logo} alt="Hardin Therapeutic Services" />
        <span className="sr-only">Hardin Therapeutic Services</span>
      </Link>
      <Menu>
        <ul>
          <li>
            <Link to="/about">About</Link>
          </li>
          <li>
            <Link to="/services">Services</Link>
          </li>
          <li>
            <Link to="/contact">Contact</Link>
          </li>
        </ul>
      </Menu>
    </Bar>
    <Bar>
      <hr />
    </Bar>
    <Bar>
      <span>
        Copyright © {new Date().getFullYear()} Hardin Therapeutic Services
      </span>
    </Bar>
  </FooterContainer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Common/Footer/index.js